import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { z } from "zod";
import { ZodExtended } from "@/data/zod.extended";
import { CommonModels } from "@/data/common/common.models";
import { EndorsementsModels } from "./endorsements.models";

export namespace EndorsementsApi {
export const createForUser = (id: string, data: EndorsementsModels.CreateEndorsementDto, ) => { 
    return AppRestClient.post( 
        { resSchema: CommonModels.EndorsementDtoSchema }, 
        `/endorsements`,
        ZodExtended.parse(EndorsementsModels.CreateEndorsementDtoSchema, data)
, 
        
    )
};

export const request = (data: EndorsementsModels.CreateEndorsementRequestDto, ) => { 
    return AppRestClient.post( 
        { resSchema: EndorsementsModels.RequestResponseSchema }, 
        `/endorsements/request`,
        ZodExtended.parse(EndorsementsModels.CreateEndorsementRequestDtoSchema, data)
, 
        
    )
};

export const getIncoming = (limit: number, order?: string, filter?: EndorsementsModels.EndorsementPaginationFilterDto, page?: number, cursor?: string, ) => { 
    return AppRestClient.get( 
        { resSchema: EndorsementsModels.GetIncomingResponseSchema }, 
        `/endorsements/incoming`,
        {
    params: {
        order: ZodExtended.parse(z.string().nullish(), order, { type: "query", name: "order" })
, 
        filter: ZodExtended.parse(EndorsementsModels.EndorsementPaginationFilterDtoSchema.optional(), filter, { type: "query", name: "filter" })
, 
        limit: ZodExtended.parse(z.number().gte(1).lte(100).default(10), limit, { type: "query", name: "limit" })
, 
        page: ZodExtended.parse(z.number().nullish(), page, { type: "query", name: "page" })
, 
        cursor: ZodExtended.parse(z.string().nullish(), cursor, { type: "query", name: "cursor" })
, 
    },
}
    )
};

export const getOutgoing = (limit: number, order?: string, filter?: EndorsementsModels.EndorsementPaginationFilterDto, page?: number, cursor?: string, ) => { 
    return AppRestClient.get( 
        { resSchema: EndorsementsModels.GetOutgoingResponseSchema }, 
        `/endorsements/outgoing`,
        {
    params: {
        order: ZodExtended.parse(z.string().nullish(), order, { type: "query", name: "order" })
, 
        filter: ZodExtended.parse(EndorsementsModels.EndorsementPaginationFilterDtoSchema.optional(), filter, { type: "query", name: "filter" })
, 
        limit: ZodExtended.parse(z.number().gte(1).lte(100).default(10), limit, { type: "query", name: "limit" })
, 
        page: ZodExtended.parse(z.number().nullish(), page, { type: "query", name: "page" })
, 
        cursor: ZodExtended.parse(z.string().nullish(), cursor, { type: "query", name: "cursor" })
, 
    },
}
    )
};

export const getStats = () => { 
    return AppRestClient.get( 
        { resSchema: EndorsementsModels.EndorsementStatsDtoSchema }, 
        `/endorsements/stats`,
        
    )
};

export const getById = (id: string, ) => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.EndorsementDtoSchema }, 
        `/endorsements/${id}`,
        
    )
};

export const deleteEndorsement = (id: string, ) => { 
    return AppRestClient.delete( 
        { resSchema: z.void() }, 
        `/endorsements/${id}`,
        
    )
};

export const write = (id: string, data: EndorsementsModels.WriteEndorsementDto, ) => { 
    return AppRestClient.post( 
        { resSchema: CommonModels.EndorsementDtoSchema }, 
        `/endorsements/${id}/write`,
        ZodExtended.parse(EndorsementsModels.WriteEndorsementDtoSchema, data)
, 
        
    )
};

export const ignore = (id: string, ) => { 
    return AppRestClient.post( 
        { resSchema: CommonModels.EndorsementDtoSchema }, 
        `/endorsements/${id}/ignore`,
        
    )
};

export const approve = (id: string, ) => { 
    return AppRestClient.post( 
        { resSchema: CommonModels.EndorsementDtoSchema }, 
        `/endorsements/${id}/approve`,
        
    )
};

export const reject = (id: string, ) => { 
    return AppRestClient.post( 
        { resSchema: CommonModels.EndorsementDtoSchema }, 
        `/endorsements/${id}/reject`,
        
    )
};

export const updateVisibility = (id: string, data: EndorsementsModels.UpdateEndorsementVisibilityDto, ) => { 
    return AppRestClient.patch( 
        { resSchema: CommonModels.EndorsementDtoSchema }, 
        `/endorsements/${id}/visibility`,
        ZodExtended.parse(EndorsementsModels.UpdateEndorsementVisibilityDtoSchema, data)
, 
        
    )
};

}
